import { LenderOptionType } from 'Feature/V2/HbtMasterPool/components/HbtMasterPool/types';

export const removeDuplicateObjects = (array: LenderOptionType[]) => {
  const newList = new Set();

  return array.filter((item) => {
    if (!newList.has(item.lenderCode)) {
      newList.add(item.lenderCode);
      return true;
    }
    return false;
  });
};
